import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/Users/sean/app/sbc/ucla/ucla-tep-desert-map/node_modules/css-loader/dist/runtime/api.js'
import '/Users/sean/app/sbc/ucla/ucla-tep-desert-map/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/Users/sean/app/sbc/ucla/ucla-tep-desert-map/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

import bysTepMap from '~root/src/components/Map.vue?shadow'
window.customElements.define('bys-tep-map', wrap(Vue, bysTepMap))